import { Configuration } from '@/gen/api';
import { ProductList, ProductLists } from '@/models/ProductList';

interface ProductListsApi {
  listProductLists(offset?: number, limit?: number): Promise<ProductLists>;
  findProductLists(query?: string, offset?: number, limit?: number): Promise<ProductLists>;
  createProductList(productList: ProductList): Promise<void>;
  getProductList(id: string): Promise<ProductList | undefined>;
  updateProductList(id: string, productList: ProductList): Promise<void>;
  deleteProductList(id: string): Promise<void>;
}

export class ProductListsApiImpl implements ProductListsApi {
  constructor(_configuration: Configuration) {}

  async listProductLists(_offset: number = 0, _limit: number = 10): Promise<ProductLists> {
    return { items: [] };
  }

  async findProductLists(
    _query?: string,
    _offset: number = 0,
    _limit: number = 10,
  ): Promise<ProductLists> {
    return { items: [] };
  }

  async createProductList(_productList: ProductList): Promise<void> {}

  async getProductList(_id: string): Promise<ProductList | undefined> {
    return undefined;
  }

  async updateProductList(_id: string, _productList: ProductList): Promise<void> {}

  async deleteProductList(_id: string): Promise<void> {}
}

export default ProductListsApi;
